<div class="logo-context-menu" (mouseenter)="openMenu()" (mouseleave)="scheduleCloseMenu()">
  <button #trigger class="logo-trigger" type="button" (click)="toggleMenu()" (keydown.enter)="toggleMenu()" (keydown.space)="toggleMenu()" aria-haspopup="menu" [attr.aria-expanded]="isOpen">
    <img class="logo" src="./assets/images/logo-blk-001.svg" width="48" alt="Nick Hudson Dev & Design" />
		<img class="logo-dm" src="./assets/images/logo-wht-001.svg" width="48" alt="Nick Hudson Dev & Design" />
  </button>

  <div #contextMenu class="context-menu" role="menu" [class.is-open]="isOpen" [class.position-top]="positionTop" [class.position-right]="positionRight" (click)="$event.stopPropagation()" (mouseenter)="cancelCloseMenu()" (mouseleave)="scheduleCloseMenu()">
    <a class="textlink" [href]="'/'" role="menuitem" (click)="closeMenu()">
      Portfolio
    </a>
    <a class="textlink" [href]="'/blog'" role="menuitem" (click)="closeMenu()">
      Blog
    </a>
  </div>
</div>
